module.exports = {
  en: {
    'STDTRTEST1': {
      '10': 'Details Of Test Score',
      '20': 'Test Date',
      '30': 'Employee Name',
      '40': 'Test Set No.',
      '50': 'Type Of Test',
      '60': 'Choice',
      '70': 'Matching',
      '80': 'True/False',
      '90': 'Written',
      '100': 'Item No.',
      '110': 'Question',
      '120': 'Full Score',
      '130': 'Score',
      '140': 'Total'
    },
    'STDTRTEST2': {
      '10': 'Item No.',
      '20': 'Question',
      '30': 'Answer',
      '40': 'Full Score',
      '50': 'Score'
    }
  },
  th: {
    'STDTRTEST1': {
      '10': 'รายละเอียดการทดสอบ',
      '20': 'วันที่สอบ',
      '30': 'ชื่อพนักงาน',
      '40': 'รหัสชุดข้อสอบ',
      '50': 'ประเภทข้อสอบ',
      '60': 'เลือกข้อ',
      '70': 'จับคู่',
      '80': 'ถูกผิด',
      '90': 'อัตนัย',
      '100': 'ข้อที่',
      '110': 'รายละเอียดคำถาม',
      '120': 'คะแนนเต็ม',
      '130': 'คะแนนที่ได้',
      '140': 'รวม'
    },
    'STDTRTEST2': {
      '10': 'ข้อที่',
      '20': 'รายละเอียดคำถาม',
      '30': 'คำตอบ',
      '40': 'คะแนนเต็ม',
      '50': 'คะแนนที่ได้'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/stdtrtest.js